import { render, staticRenderFns } from "./TypeSpinViewer.vue?vue&type=template&id=495f6dae&scoped=true&"
import script from "./TypeSpinViewer.vue?vue&type=script&lang=js&"
export * from "./TypeSpinViewer.vue?vue&type=script&lang=js&"
import style0 from "./TypeSpinViewer.vue?vue&type=style&index=0&id=495f6dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495f6dae",
  null
  
)

export default component.exports